import {
    FetchState
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import {
    TerminationReasonState,
    TerminationReason
} from "@/admin/types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: TerminationReasonState = {
    fetchState: FetchState.Uninitialized,
    terminationReasons: []
};

export const useTerminationReasonStore = defineStore("terminationReason", {
    state: (): TerminationReasonState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setTerminationReasons (terminationReasons: TerminationReason[]) {
            this.terminationReasons = [ ...terminationReasons ];
        },
        getTerminationReasons () {
            return new Promise<void>((resolve, reject) => {
                if (this.fetchState !== FetchState.Uninitialized) {
                    resolve();
                    return;
                } else {
                    this.setFetchState(FetchState.Loading);
                    return UserService.getTerminationReasons().then(resp => {
                        this.setTerminationReasons(resp.data);
                        this.setFetchState(FetchState.Loaded);
                    }).catch(err => {
                        storeHelper.handleError({ error: err, rethrow: true });
                    });
                }
            });
        },
    }
});